import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    position: "fixed",
    bottom: "var(--rhythm)",
    left: "var(--rhythm)",
    "& .MuiSpeedDial-fab": {
      color: "var(--color-white)",
      background: "var(--color-primary)",
      "&:hover": {
        background: "var(--color-primary)",
      },
    },
    "& .MuiSpeedDialIcon": {
      background: "var(--color-primary)",
      "&:hover": {
        background: "var(--color-primary)",
      },
    },
  },
});
